import React, { useCallback, useEffect, useState } from 'react';

import cn from 'classnames';

import Button from 'components/Button';
import IconFemtasy from 'components/IconFemtasy';
import Loader from 'components/Loader';
import VisualTileSkeleton from 'components/VisualTileSkeleton';

import {
  PlaylistImageFragment,
  usePlaylistImagesQuery,
} from 'graphql/generated/graphql';

import useGraphaelDefaults from 'hooks/useGraphaelDefaults';
import './style.scss';

interface PlaylistImageSelectorProps {
  onClick: (selectedPlaylist: PlaylistImageFragment, position: number) => void;
  buttonTranslationId: string;
  selectedImageId?: string;
}

const PlaylistImageSelector = ({
  onClick,
  buttonTranslationId,
  selectedImageId,
}: PlaylistImageSelectorProps) => {
  const { data, loading } = usePlaylistImagesQuery({
    ...useGraphaelDefaults(),
    fetchPolicy: 'no-cache',
    variables: {
      showInCreationDialog: true,
    },
  });

  const [selectedPlaylistImage, setSelectedPlaylistimage] = useState<{
    playlistImage: PlaylistImageFragment;
    position: number;
  } | null>(null);

  useEffect(() => {
    if (data && selectedImageId) {
      const selectedImage = data.playlistImages.find(
        (image) => image.id === selectedImageId,
      );

      if (selectedImage)
        setSelectedPlaylistimage({
          playlistImage: selectedImage,
          position: data.playlistImages.indexOf(selectedImage),
        });
    }
  }, [data, selectedImageId]);

  const handleOnClick = useCallback(() => {
    if (selectedPlaylistImage) {
      onClick(
        selectedPlaylistImage.playlistImage,
        selectedPlaylistImage.position,
      );
    }
  }, [onClick, selectedPlaylistImage]);

  return (
    <div className="PlaylistImageSelector">
      <div className="PlaylistImageSelector__content">
        {loading && <Loader />}
        {data &&
          data.playlistImages &&
          data.playlistImages.map((image, position) => {
            if (!image.image) return null;
            return (
              <div key={image.id} className="PlaylistImageSelector__image">
                {image.id === selectedPlaylistImage?.playlistImage.id && (
                  <div className="check">
                    <IconFemtasy icon="Check" color="white" />
                  </div>
                )}
                <VisualTileSkeleton
                  src={image.image}
                  alt={`Playlist image ${image.id}`}
                  className={cn({
                    selected:
                      image.id === selectedPlaylistImage?.playlistImage.id,
                  })}
                  onClick={() => {
                    setSelectedPlaylistimage({
                      playlistImage: image,
                      position,
                    });
                  }}
                />
              </div>
            );
          })}
      </div>
      <Button
        variant="primary"
        onClick={handleOnClick}
        title={{
          id: buttonTranslationId,
        }}
        disabled={!selectedPlaylistImage}
      />
    </div>
  );
};

export default PlaylistImageSelector;
